import { t } from 'i18next'

import { isForRuMarket } from './constants'

export const getHrmName = () => (isForRuMarket ? t('App.hrmka') : t('App.hrmessenger'))

// Получить предпочтительный цвет контрастного цвета относительно фона - белый или черный
export const getColorByContrast = (color: string): 'black' | 'white' => {
  const clr = color.replace('#', '')
  const r = parseInt(clr.substring(0, 2), 16)
  const g = parseInt(clr.substring(2, 4), 16)
  const b = parseInt(clr.substring(4, 6), 16)
  const yiq = (r * 299 + g * 587 + b * 114) / 1000

  return yiq >= 180 ? 'black' : 'white'
}
